import { ReactElement, ReactNode, useContext } from 'react';
import { AuthContext } from '@urbanx/agx.auth.client';
import { cleanFullAddress, PropertyAddress } from '@urbanx/agx-ui-components';
import { AgxColumn, AgxDivider, AgxRow, AgxTypography } from '@urbanx/agx.ui-components2';
import LeftSubmenu, { SubPage } from 'components/left-submenu/LeftSubmenu';
import { MenuTitles, Pages } from 'constants/menu';
import { useSelectedAgency, useSelectedCampaign } from 'hooks';
import { ContentLayout, PageLayout } from 'layout';
import './ContractSubPage.scss';

interface ContractPageScaffoldProps {
  pageTitle: string;
  secondaryActiveMenu: MenuTitles;
  currentPage: Pages;
  subPages: SubPage[];
  children: ReactNode;
  headerAction?: ReactElement;
  secondaryActions?: ReactElement;
  beforeContent?: ReactNode;
}

export const ContractPageScaffold = ({
  pageTitle,
  secondaryActiveMenu,
  currentPage,
  subPages,
  children,
  headerAction,
  secondaryActions,
  beforeContent,
}: ContractPageScaffoldProps) => {
  const { userAccount } = useContext(AuthContext);
  const { agency } = useSelectedAgency();
  const { campaign, isLoading } = useSelectedCampaign();

  if (isLoading || !campaign) return null;

  return (
    <PageLayout
      agentName={userAccount?.firstName || ''}
      primaryPageTitle={agency?.name || ''}
      currentPageTitle={`Campaigns / ${cleanFullAddress(campaign.address as PropertyAddress)}`}
      isCampaignsSection
    >
      <ContentLayout
        hasSecondaryMenu={false}
        secondaryActiveMenu={secondaryActiveMenu}
        isContracts
        secondaryActions={secondaryActions}
      >
        {beforeContent}
        <AgxColumn gap="spacing-xl" fill>
          <AgxColumn gap="sm" fill id="subPageHeadingContainer">
            <AgxRow
              id="subPageHeading"
              gap="spacing-md"
              fill
              padding={{ left: 'spacing-md', right: 'spacing-md' }}
              justifyContent="center"
              alignItems="alignCenter"
            >
              <AgxRow gap="spacing-md" fill alignItems="flex-start" justifyContent="space-between">
                <AgxTypography
                  id={`pageTitle-${pageTitle.replace(/\s+/g, '-')}`}
                  type="body_ui"
                  size="medium"
                >
                  {pageTitle}
                </AgxTypography>
              </AgxRow>
              {headerAction}
            </AgxRow>
            <AgxDivider variant="horizontal" pushMargin="spacing-3xl" />
          </AgxColumn>
          <AgxRow gap="spacing-md" fill>
            <LeftSubmenu currentPage={currentPage} subPages={subPages} />
            <AgxColumn gap="spacing-xl" fill>
              {children}
            </AgxColumn>
          </AgxRow>
        </AgxColumn>
      </ContentLayout>
    </PageLayout>
  );
};
